class FaqlandingController {
  constructor($state, $rootScope, $timeout, laboxSSapi) {
    this.name = 'Quick Tips';
    this.faqlandingLoader = true;
    this.faqlandingerror = true;

    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.isCablevision = this.$rootScope.isCablevision;
    this.isSuddenlink = this.$rootScope.isSuddenlink;

    if (this.isCablevision == true) {
      laboxSSapi.getOptFaq().then((res) => {
        this.faqlandingerror = false;
        this.faqlandingLoader = false;
      }, (reserr)=> {
        console.log('fail ---> ', reserr);
        this.faqlandingerror = true;
        this.faqlandingLoader = false;
      });
    } else if (this.isSuddenlink == true) {
      laboxSSapi.getSdlFaq().then((res) => {
        this.faqlandingerror = false;
        this.faqlandingLoader = false;
      }, (reserr)=> {
        console.log('fail ---> ', reserr);
        this.faqlandingerror = true;
        this.faqlandingLoader = false;
      });
    }
    
    this.state = $state;
  }
}

FaqlandingController.$inject = [
  '$state',
  '$rootScope',
  '$timeout',
  'laboxSSapi'
];

export default FaqlandingController;



// WEBPACK FOOTER //
// ./client/app/components/landingpage/faqlanding/faqlanding.controller.js